import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import Search from "../../components/search/search";
import CustomCheckBox from "../../components/UI/customCheckBox/customCheckBox";
import CustomButton from "../../components/UI/customButton/customButton";
import {Get, Post} from "../../apis/api";
import CustomSelect from "../../components/UI/customSelect/customSelect";
import {toast} from "react-toastify";
import LoadingFix from "../../components/loading-fix/loading-fix";

const Setting = () => {
  const {t} = useTranslation();
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState( [])
  const [roleList, setRoleList] = useState( [])
  const [roleDetails, setRoleDetails] = useState( [])
  const [permissions, setPermissions] = useState( [])
  const [form, setForm] = useState({})
  useEffect(() => {
    handleList()

  } ,[])
  const handleList = () => {
    setLoading(true)
    Get(`roles` ).then((res) =>{
      setData(res?.details)
      setRoleList(res?.details)
    })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => {
      setLoading(false)
    })
  }



  const handleVisa = () => {
    const newList = []
    data?.forEach((item) => {
      newList.push({fa_name: item?.title , en_name: item?.title , id:item.role_key})
    })
    return newList
  }
  const handleRole = (id) => {

    return roleList?.find((item => {
      return (
        item.role_key === id
      )
    }))
  }
  const handleForm = ({name, value}) => {
     setForm((prevState) => ({...prevState, [name]: value}))
  }


  const handlePermissions = ({ id, access }) => {
    setPermissions((prevState) => {
      const existingPermissionIndex = prevState.findIndex(permission => permission.id === id);

      if (existingPermissionIndex !== -1) {
        if (!access) {
          return prevState.map(permission =>
            permission.id === id ? { ...permission, access: false } : permission
          );
        } else {
          return prevState.map(permission =>
            permission.id === id ? { ...permission, access: true } : permission
          );
        }

      } else {
        if (access) {
          return [...prevState, { id, access }];
        }
        return prevState;
      }
    });
  };

  const handleSubmit = () => {
    setLoading(true)
    Post(`roles/${ `update/${handleRole(form["role_key"])?.id}`}` , {role_key:form.role_key , title:form.role_key , full_access:0 ,is_admin:0 , "permissions" : [
        ...permissions
      ]
    }).then((res) =>{
      toast.success(res.msg)
      setData(res?.details?.data)
    }).catch((error) => {
      toast.error(error.data.message || error.data.msg)
    })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    if(handleRole(form["role_key"])?.id) {
      setLoading(true)
      Get(`roles/show/${handleRole(form["role_key"])?.id}` ).then((res) =>{
        setRoleDetails(res.details)
        setPermissions([
          {
            id:res.details?.role_permissions?.BasicInformation[0]?.id,
            access:res.details?.role_permissions?.BasicInformation[0]?.access,
          },
          {
            id:res.details?.role_permissions?.Finance[0]?.id,
            access:res.details?.role_permissions?.Finance[0]?.access,
          },
          {
            id:res.details?.role_permissions?.Permission[0]?.id,
            access:res.details?.role_permissions?.Permission[0]?.access,
          },
          {
            id:res.details?.role_permissions?.User[0]?.id,
            access:res.details?.role_permissions?.User[0]?.access,
          },
          {
            id:res.details?.role_permissions?.Visa[0]?.id,
            access:res.details?.role_permissions?.Visa[0]?.access,
          },
        ])
      })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          setLoading(false)
        })
    }
  } ,[handleRole(form["role_key"])?.id])

  return (
    <>
      {
        loading && <LoadingFix/>
      }
      <div className={"my-container  bg-white rounded-lg  flex flex-col gap-9 w-full !mt-5 overflow-hidden py-5 px-4 md:px-[15%] mb-8"}>
        <div className={"text-start text-gray-500"}>
          {t("settingTitle")}
        </div>
        <span className={"w-full"}>
                 <CustomSelect
                   name="role_key"
                   label={t("roles")}
                   options={handleVisa()}
                   onchange={(e) => handleForm(e)}
                   defaultValue={handleRole(form["role_key"])}
                 />
        </span>
        <div className={"flex flex-col md:flex-row justify-between"}>
          <div className={"font-normal mb-5 md:mb-0 text-gray-500"}>
            {t("basicInformation")}
          </div>
          <div className={"flex w-full md:w-1/2 justify-end"}>
            <CustomCheckBox defaultValue={permissions?.[0]?.access} disable={roleDetails?.length === 0} onCheck={(e) => handlePermissions({id:roleDetails?.role_permissions?.BasicInformation[0].id , access:e})}  label={"see"}/>
          </div>
        </div>

        <div className={"flex flex-col md:flex-row justify-between"}>
          <div className={"font-normal mb-5 md:mb-0 text-gray-500"}>
            {t("crew")}
          </div>
          <div className={"flex w-full md:w-1/2 justify-end"}>
            <CustomCheckBox defaultValue={permissions?.[3]?.access} disable={roleDetails?.length === 0} onCheck={(e) => handlePermissions({id:roleDetails?.role_permissions?.User[0].id , access:e})} label={"see"}/>
          </div>
        </div>
        <div className={"flex flex-col md:flex-row justify-between"}>
          <div className={"font-normal mb-5 md:mb-0 text-gray-500"}>
            {t("visaOrders")}
          </div>
          <div className={"flex w-full md:w-1/2 justify-end"}>
            <CustomCheckBox defaultValue={permissions?.[4]?.access} disable={roleDetails?.length === 0} onCheck={(e) => handlePermissions({id:roleDetails?.role_permissions?.Visa[0].id , access:e})} label={"see"}/>
          </div>
        </div>
        <div className={"flex flex-col md:flex-row justify-between"}>
          <div className={"font-normal mb-5 md:mb-0 text-gray-500"}>
            {t("transactions")}
          </div>
          <div className={"flex w-full md:w-1/2 justify-end"}>
            <CustomCheckBox defaultValue={permissions?.[1]?.access} disable={roleDetails?.length === 0} onCheck={(e) => handlePermissions({id:roleDetails?.role_permissions?.Finance[0].id , access:e})} label={"see"}/>
          </div>
        </div>

        <div className={"flex flex-col md:flex-row justify-between"}>
          <div className={"font-normal mb-5 md:mb-0 text-gray-500"}>
            {t("setting")}
          </div>
          <div className={"flex w-full md:w-1/2 justify-end"}>
            <CustomCheckBox defaultValue={permissions?.[2]?.access} disable={roleDetails?.length === 0} onCheck={(e) => handlePermissions({id:roleDetails?.role_permissions?.Permission[0].id , access:e})} label={"see"}/>
          </div>
        </div>
      </div>
      <div className={"my-container flex md:justify-end  "}>
        <div className={'w-full md:w-[330px] mb-10 mt-8 md:mt-0'}>
          <CustomButton disable={roleDetails?.length === 0} onClick={handleSubmit} title={"save"}/>
        </div>
      </div>
    </>
  );
};

export default Setting;
